import { useState, useEffect } from "react";
import { Input } from "antd";
import useUserStore from "../../../stores/store";
import { getQueryParamsOrderForm } from "../../../services/order-add-edit-service";
import { CharLimit as charLimit } from "../../../constant/constants";
import CustomInputNumberV2 from "../../CustomInputNumberV2";
import OrderTypeComponent from "./OrderTypeComponent";
import useTableManagementStorage from "../../../stores/useTableManamentStore";
import { getOrCreateSessionId } from "../../../utils/Common";
import { updateGuestNumber } from "../../../utils/store-mutator.table-management";

const sessionId = getOrCreateSessionId();

export default function OrderFormInputsComponent({ fields, onChangeFields }) {
  const { isTableManagement } = getQueryParamsOrderForm();
  const { user } = useUserStore();
  const { idWiseGuestNumber } = useTableManagementStorage();

  function onHandleMobileNo(e) {
    const val = e.target.value;

    if ((/^[1-9][0-9]*$/.test(val) || val === "") && val.length <= 10) {
      onChangeFields("mobileNo", val);
    }
  }

  function onHandleTableNo(val) {
    onChangeFields("tableNo", val);
  }

  function onHandleGuestNo(val) {
    // onChangeFields("guestNo", val);
    updateGuestNumber(val);
  }

  function onHandlePreparingTime(e) {
    const value = e.target.value;
    if (/[^\d]/.test(value)) {
      return;
    }

    if (value.length < 3) {
      onChangeFields("preparingTime", value);
    }
  }

  function onHandleOrderType(e) {
    const tempOrderType = e.target.value;
    onChangeFields("orderType", tempOrderType);
  }

  function onHandleTakeoutType(val) {
    onChangeFields("takeoutType", val);
  }

  function onHandleSpecialInstruction(e) {
    const val = e.target.value;

    if (val.length > charLimit.Address) return;
    onChangeFields("specialInstruction", val);
  }

  useEffect(() => {
    updateGuestNumber(fields.guestNo);
  }, [fields.guestNo])

  return (
    <div className="bg-[#FDEEA1] w-full px-4 py-4 border border-[#E4E4E4]">
      <div className="flex flex-col lg:flex-row items-center gap-4">
        {/* Mobile number */}
        <div className="w-full flex">
          <input
            name="countryCode"
            value={"+880"}
            onChange={() => {}}
            className="w-[25%] h-[32px] outline-none border border-[#D5D8DB] rounded-l-[4px] indent-[5px] bg-gray-200"
          />
          <input
            name="mobileNo"
            className="w-[75%] h-[32px] outline-none border border-[#D5D8DB] rounded-r-[4px] indent-[8px] no-number-spinner"
            placeholder={user?.phone || ""}
            value={fields.mobileNo}
            type="number"
            maxLength={10}
            onChange={(e) => onHandleMobileNo(e)}
            onKeyDown={(e) => {
              if (["-", "+", "e", "ArrowUp", "ArrowDown", ".", "Decimal"].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </div>

        {/* Table No */}
        {!isTableManagement && (
          <div className="w-full">
            <CustomInputNumberV2
              name="tableNo"
              value={fields.tableNo}
              setValue={onHandleTableNo}
              min={0}
              max={99999}
              placeholder={""}
              addonBefore="Table No"
            />
          </div>
        )}
        {isTableManagement && (
          <div className="w-full">
            <CustomInputNumberV2
              name="guestNo"
              value={idWiseGuestNumber[sessionId]}
              setValue={onHandleGuestNo}
              min={0}
              max={99999}
              placeholder={"1"}
              addonBefore="Guests No"
            />
          </div>
        )}

        {/* Preparing time */}
        <div className="w-full bg-gray-200 relative">
          <Input
            addonAfter={"min"}
            value={fields.preparingTime}
            onChange={onHandlePreparingTime}
            placeholder="Enter number up to 99"
          />
          <div className="text-sm" style={{ position: "absolute" }}>
            Preparing Time <span className="text-red-600">*</span>
          </div>
        </div>
      </div>

      {/* order type */}
      <OrderTypeComponent
        orderType={fields.orderType}
        takeoutType={fields.takeoutType}
        onHandleOrderType={onHandleOrderType}
        onHandleTakeoutType={onHandleTakeoutType}
      />

      {/* special instruction */}
      <div className="mt-4 w-full">
        <input
          name="specialInstruction"
          value={fields.specialInstruction}
          className="w-full h-[32px] indent-[8px] rounded-[4px]"
          placeholder="Special Instruction"
          onChange={(e) => onHandleSpecialInstruction(e)}
        />

        <div className="mt-1 text-[12px] text-gray-600 italic">
          Char limit {charLimit.Address}. Current: {fields.specialInstruction.length}
        </div>
      </div>
    </div>
  );
}
